module.exports = __webpack_public_path__ + "img/1490870073.9b7f12bf.jpg";